<template>
    <div>

        <PageHeader>
            {{ $t('reportsCategories') }}
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonIcon icon="filter" :title="$t('restoreFiltersToTheDefaultSettings')" class="rounded-circle p-1 height-40 width-40" variant="light" @click="$emit('resetFilters')" />
                    <TimeRangeCalendar v-model="timeRange" compare-year />
                </div>
            </template>
        </PageHeader>

        <ImpressionsReport />

        <SalesReport />

        <CategoryReport />

        <CategoryRanking />

        <CategoryHeatmap />

    </div>
</template>



<script>
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';
    import ImpressionsReport from './parts/ImpressionsReport.vue';
    import SalesReport from './parts/SalesReport.vue';
    import CategoryReport from './parts/CategoryReport.vue';
    import CategoryRanking from './parts/CategoryRanking.vue';
    import CategoryHeatmap from './parts/CategoryHeatmap.vue';

    export default {
        name: 'ReportsCategories',
        components: {
            TimeRangeCalendar,
            ImpressionsReport,
            SalesReport,
            CategoryReport,
            CategoryRanking,
            CategoryHeatmap,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
            };
        },
    };
</script>
